

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _squid = require('squid');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(0, _squid.$registerDirective)('xoModal', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        replace: true,
        transclude: true,

        scope: {
            show: '=?',
            showCloseButton: '=?',
            overrideDefaultContainer: '@?' // Boolean to determine if default styling should be applied to container
        },

        controller: function controller($scope) {
            var $body = (0, _jquery2['default'])('body');
            var keyupEvent = 'keyup.modal';

            $scope.hideModal = function ($event) {
                $event.preventDefault();
                $scope.show = false;
            };

            $scope.$watch('show', function (showModal) {

                if (showModal) {
                    // move the focus to modal
                    (0, _jquery2['default'])('.modalContent').focus();

                    // when the esc key is pressed
                    $body.on(keyupEvent, function ($event) {
                        if ($event.which === 27) {
                            $scope.$apply(function () {
                                $scope.hideModal($event);
                            });
                            $body.off(keyupEvent);
                        }
                    });
                } else {
                    $body.off(keyupEvent);
                }
            });
        }
    };
});

_squid.$registerDirective;


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-ui-components/src/modal/directive.js
 ** module id = 365
 ** module chunks = 1
 **/